import { createSelector } from "@reduxjs/toolkit";
import { SOCIAL_MEDIA_PLATFORM_STATUS } from "constants/phase";
import { socialMediaPlatforms } from "constants/v2/publishModalConstants";

import { socialProfileAdapter, socialProfileSlice } from "./slice";

const selectSocialProfileState = (state) => state[socialProfileSlice.name];

export const selectAllSocialProfiles = createSelector(selectSocialProfileState, (socialProfileState) =>
  socialProfileAdapter.getSelectors().selectAll(socialProfileState),
);

export const selectSocialProfileEntities = createSelector(selectSocialProfileState, (socialProfileState) =>
  socialProfileAdapter.getSelectors().selectEntities(socialProfileState),
);

export const selectSocialProfileById = createSelector(
  selectSocialProfileState,
  (_, props) => props.profileId,
  (socialProfileState, id) => socialProfileAdapter.getSelectors().selectById(socialProfileState, id),
);

export const selectSocialProfilePlatformDetails = createSelector(
  selectSocialProfileById,
  (_, props) => props.platform,
  (socialProfile, platform) => {
    const normalizedPlatform = platform?.toLowerCase() === "x" ? "twitter" : platform;

    return socialProfile?.platforms?.find((item) => item.platform === normalizedPlatform);
  },
);

export const selectSocialProfilePlatformStatus = createSelector(
  selectSocialProfilePlatformDetails,
  (socialProfilePlatformDetails) => {
    return socialProfilePlatformDetails?.status;
  },
);

export const selectSocialProfilePlatformIsConnected = createSelector(selectSocialProfilePlatformStatus, (status) => {
  return status === SOCIAL_MEDIA_PLATFORM_STATUS.CONNECTED;
});

export const selectSocialProfilePlatformIsIncomplete = createSelector(selectSocialProfilePlatformStatus, (status) => {
  return status === SOCIAL_MEDIA_PLATFORM_STATUS.INCOMPLETE;
});

export const selectSocialProfilePlatformDisplayName = createSelector(
  selectSocialProfilePlatformDetails,
  (socialProfilePlatformDetails) => {
    return socialProfilePlatformDetails?.displayName;
  },
);

export const selectSocialProfilePlatformUserImage = createSelector(
  selectSocialProfilePlatformDetails,
  (socialProfilePlatformDetails) => {
    return socialProfilePlatformDetails?.userImage;
  },
);

export const selectSocialProfileTitle = createSelector(selectSocialProfileById, (socialProfile) => {
  return socialProfile?.title || "";
});

export const selectSocialProfileByPlatform = createSelector(
  selectAllSocialProfiles,
  (_, props) => props.platform,
  (socialProfiles, platform) => {
    const platformMap = {
      [socialMediaPlatforms.instagramStory.platform]: "instagram",
      [socialMediaPlatforms.youtubeShorts.platform]: "youtube",
      [socialMediaPlatforms.snapchatStory.platform]: "snapchat",
      [socialMediaPlatforms.snapchatSpotlight.platform]: "snapchat",
    };

    return socialProfiles.filter(({ activeSocialAccounts }) =>
      activeSocialAccounts?.includes(platformMap[platform] || platform),
    );
  },
);
